export default __webpack_public_path__ + "static/media/MUSSELS.f253b3a8.svg";